import { NotificationsPreferencesControls } from "@/features/predictions/components/shared/NotificationsPreferencesControls";
import { useMyPronosticsPreferences } from "@/features/predictions/hooks/useMyPronosticsPreferences";
import { H2 } from "@/shared/ui/typographies/h2";
import { P } from "@/shared/ui/typographies/paragraph";

export const NotificationsStep = () => {
  const { data: preferences, isLoading, isError } = useMyPronosticsPreferences();

  return (
    <div className="space-y-5 text-left">
      <div className="space-y-2 text-center">
        <H2>Reste dans le match</H2>
        <P color="muted" size="sm">
          Choisis comment on te tient au courant.
        </P>
      </div>

      {isLoading && (
        <ul className="space-y-2" aria-hidden>
          {[0, 1].map((index) => (
            <li
              key={index}
              className="flex h-[60px] animate-pulse items-center rounded-lg bg-gray-100 px-4 dark:bg-gray-700/60"
            />
          ))}
        </ul>
      )}

      {isError && (
        <p className="text-center text-xs text-gray-500 dark:text-gray-400">
          Impossible de charger tes préférences pour le moment.
        </p>
      )}

      {preferences && <NotificationsPreferencesControls preferences={preferences} />}
    </div>
  );
};

NotificationsStep.displayName = "NotificationsStep";
